export const displayAskGetLocationSelector = ({displayAskGetLocation}) => displayAskGetLocation